// extracted by mini-css-extract-plugin
export default {"body-1":"DroT3BXsQNmeUdgC80qB","body-2":"liRjPhLn3zQDpY4Z3giz","body-3":"eH0ImmKktRSdcix0evQv","ant-typography":"MhLdmumYg7nyJwzwl1Fm","list":"VlxyQm67gPF5gsagFB1H"};